import { cva } from 'class-variance-authority'

export const toggleVariants = cva(
  `
    inline-flex
    items-center
    justify-center
    gap-2
    rounded-lg
    text-sm
    text-neutral-700
    font-medium
    transition-[background-color] duration-150 ease-in-out
    hover:bg-muted
    data-[state=on]:bg-accent
    focus-visible:outline-none
    focus-visible:ring-1
    focus-visible:ring-ring
    disabled:pointer-events-none
    disabled:opacity-50
    [&_svg]:pointer-events-none
    [&_svg]:size-4
    [&_svg]:shrink-0
    `,
  {
    variants: {
      variant: {
        default: `
          hover:text-muted-foreground
          data-[state=on]:text-accent-foreground
          bg-transparent
          hover:bg-neutral-50
          data-[state=on]:bg-green-0
          data-[state=on]:text-green-100
          data-[state=on]:hover:bg-green-0
          data-[state=on]:hover:text-green-100
          disabled:bg-neutral-50
          disabled:text-neutral-700
          `,
        outline: `
          hover:text-muted-foreground
          data-[state=on]:text-accent-foreground
          border-1
          border-neutral-200
          bg-transparent
          hover:bg-neutral-50
          hover:text-accent-foreground
          hover:border-accent
          data-[state=on]:bg-green-0
          data-[state=on]:text-green-100
          data-[state=on]:border-green-50
          data-[state=on]:hover:bg-green-0
          data-[state=on]:hover:text-green-100
          data-[state=on]:hover:border-green-50
          data-[state=on]:hover:bg-gradient-to-b:none
          `,
        /**
         * Multi-line toggle card — used for grouped options that need a title,
         * an optional inline tag, and a caption (e.g. Business/Personal/Mix).
         * Overrides the shared base's inline layout + hover/selected
         * background (text color is left at the base's neutral-700, unlike
         * `default`/`outline` which tint text on hover/select).
         */
        card: `
          flex
          flex-col
          items-start
          justify-start
          gap-0
          text-left
          w-full
          h-auto
          border
          border-neutral-200
          bg-neutral-0
          hover:bg-neutral-50
          hover:border-neutral-400
          data-[state=on]:bg-green-0
          data-[state=on]:border-green-50
          data-[state=on]:hover:bg-green-0
          data-[state=on]:hover:border-green-50
          `,
      },
      size: {
        sm: `
          h-8
          px-2.5
          py-2
          min-w-8
          `,
        lg: `
          h-10
          px-3
          py-2
          min-w-10
          `,
        card: `
          px-3
          py-2.5
          min-w-8
          `,
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'sm',
    },
    compoundVariants: [
      // `card` is a fundamentally different (auto-height, full-width) layout
      // than sm/lg. If a consumer renders `variant="card"` without also
      // passing `size="card"`, `size` falls back to the `sm` default and its
      // fixed height/padding would win over the variant's via twMerge
      // (size classes are resolved after variant classes). Force the card
      // sizing back on for any size so `variant="card"` is safe on its own.
      {
        variant: 'card',
        size: ['sm', 'lg'],
        class: 'h-auto px-3 py-2.5 min-w-8',
      },
    ],
  }
)
